import styled from 'styled-components'
import Image from 'next/legacy/image'
import Link from 'next/link'
import { Typography } from 'common/typography'
import { SecondaryButton } from 'common/button'
import ContentRender from 'content-renderer'
import useSession from 'querys/session'
import { useRouter } from 'next/router'
import LearningPlanTag from './learning-plan-tag'
import ProjectStatus from './learning-plan-progress/project-in-progress-state'

const LearningPlanProjectItemStyled = styled.li`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  position: relative;
  .project-badge {
    position: relative;
  }
  .badge {
    background: #3b3f56;
    width: 40px;
    height: 40px;
    transform: rotateX(25deg) translateZ(-14px) translateY(-10px);
    box-shadow: 0 8px 0 #20203a;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    padding: 8px;
    box-sizing: border-box;
    flex-shrink: 0;
    z-index: 2;
    cursor: pointer;
    transition: .3s filter, .2s box-shadow;
    ${({ completed }) => (completed ? `
      box-shadow: 0 6px 0 #20203a, 0 6px 15px #10FEFE;
    ` : null)}
    &:hover {
      box-shadow: 0 6px 0 #20203a, 0 6px 15px #10FEFE;
    }
    &:active {
      box-shadow: none;
      position: relative;
      cursor: pointer;
      top: 4px;
    }
    span {
      vertical-align: middle;
      border-radius: 50%;
    }
  }

  .learning-path-tooltip {
    bottom: 0;
    max-inline-size: 328px;
    display: flex;
    position: absolute;
    flex-direction: column;
    gap: 8px;
    background: var(--neutral90);
    border-radius: 1.5rem;
    padding: 24px;
    box-sizing: border-box;
    color: var(--white);
    filter: drop-shadow(0px 0px 20px #6170d850);
    z-index: -1;
    line-height: 22px;
    font-size: 14px;
    opacity: 0;
    p {
      color: var(--white);
    }
    &:after {
      content: "";
      position: absolute;
      display: block;
      width: 12px;
      height: 8px;
      z-index: 2;
      top: -6px;
      left: calc(50% - 6px);
      background: var(--neutral90);
      clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
    }
    ul {
      display: flex;
      gap: .5rem;
      flex-direction: column;
    }
    &-spacer {
      height: 30px;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 100%;
    }
  }


  .project-state {
    display: flex;
    align-items: center;
    gap: .25rem;
    font: var(--p2Regular);
    color: var(--turquoise);
  }
  .project-summary p {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin: 0;
  }
  &:last-of-type .learning-path-tooltip {
    top: initial;
    bottom: 125%;
    &:after {
      top: initial;
      bottom: -6px;
      transform: rotate(180deg);
    }
  }
  .project-title {
    display: flex;
    align-items: center;
    gap: 8px;
    .aproved {
      color: var(--turquoise);
      font: var(--smallRegular);
    }
  }
  @media (min-width: 1024px) {
    .learning-path-tooltip {
      top: calc(100% + 1rem);
      right: 0;
      left: 0;
      bottom: auto;
      min-inline-size: 380px;
      transform: translateX(-50%) scale(.1);
      left: 50%;
      opacity: 0;
      transition: .3s transform;
      transform-origin: top;
      z-index: 5;
      ${({ $isActive }) => $isActive && (`
        transform: translateX(-50%) scale(1);
        opacity: 1;
        visibility: visible;
      `)}
    }
  }
`

function LearningPlanProjectItem({
  uuid, title, slug, thumb_image, description, progress_status, itemActive, setItemActive,
}) {
  const isActive = itemActive === title
  const router = useRouter()

  function handleClick() {
    isActive ? setItemActive('') : setItemActive(title)
  }

  function handleLinkClick() {
    const isMobile = window.matchMedia('(max-width: 1023px)').matches
    if (!isMobile) return
    router.push(`/proyectos/${slug}`)
  }

  return (
    <LearningPlanProjectItemStyled onClick={handleLinkClick} className="learning-plan-step" $isActive={isActive}>
      <div className="project-badge">
        <div
          className="badge"
          role="button"
          onClick={handleClick}
          aria-hidden="true"
        >
          <Image
            src={thumb_image}
            width={28}
            height={28}
          />
        </div>
        <div className="learning-path-tooltip">
          <div className="learning-path-tooltip-spacer" />
          {progress_status?.status ? (
            <>
              <Typography font="regularBold">
                {title}
              </Typography>
              <ProjectStatus status={progress_status.status} feedback={progress_status.feedback} />
            </>
          ) : (
            <div className="project-summary">
              <ContentRender chunks={description.blocks.slice(0, 1)} font="p2Regular" />
            </div>
          )}
          <Link href={`/proyectos/${slug}`} passHref>
            <SecondaryButton fullWidth>
              Ir al proyecto
            </SecondaryButton>
          </Link>
          {/* TODO: Añadir proyecto al portafolio desde aca */}
        </div>
      </div>
      <div>
        <LearningPlanTag project />
        <div className="project-title">
          <Typography>
            {title}
          </Typography>
          {progress_status?.status === 'COMPLETED' ? (
            <div>
              <img src="/images/profile/aproved-icon.png" width="24" height="24" alt="Icono del estado del proyecto" />
              <span className="aproved">Aprobado</span>
            </div>
          ) : null}
        </div>
      </div>

    </LearningPlanProjectItemStyled>
  )
}

export default LearningPlanProjectItem
